
import React, { Component } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Badge, CardBody } from 'reactstrap';

import ExportDeviceSettings from './ExportDeviceSettings.js';
import ExportDeviceDashboard from './ExportDeviceDashboard.js';

class ExportDevice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      currentPageTabId: '',
      is1stTab: '',
      is2nsTab: '',
      random_string: Math.random().toString(36).substring(7),

      lblExplblmsg016: "Dashboard",
      lblExplblmsg017: "Settings"
    }
  }

  componentDidMount() {
    // Check if firebase exists and if the currentUser is available
    if (this.props.currentUser) {
      
      try {
        const currentUser = this.props.currentUser;
        let alias_email = null;
  
        // Check if providerData exists and has values
        if (currentUser.hasOwnProperty('providerData') && currentUser.providerData.length > 0) {
          alias_email = currentUser.providerData[0].email;
        }
  
        // Prepare the sentData for the API request
        const sentData = {
          method: 'POST',
          body: JSON.stringify({
            uid: this.props.uid,
            email: currentUser.email,
            alias_email: alias_email,
            mobile: currentUser.phoneNumber,
            name: currentUser.displayName,
            created_by: null,
          }),
        };
  
        // Log the firebase object for debugging
  
        // Make the API call and await its result
        const response = fetch(process.env.REACT_APP_URL + "/user?uid=" + this.props.uid, sentData)
        .then(res => res.json())
        .then(details => {
          if (details.code === 211 && this.props.firebase) {
            this.props.onLogout();
          }
          this.fetchDisplayStatusDetails();
        });
  
        // Check if the response code is 211, and log out if so
        
      } catch (error) {
        // Handle errors, update state if needed
        //this.setState({ IsError: true });
      }
    }
    else{
      this.fetchDisplayStatusDetails();
    }
  
    // Always fetch display status details
    
  }
  


  toggle(tab) {
    if (tab === "2") {
      this.setState({
        random_string: Math.random().toString(36).substring(7)
      })
    }
    this.setState({
      activeTab: tab,
    });
  }

  renderdata = () => {
    return (
      <>
        {this.state.is1stTab > 0 ?
          <TabPane tabId="1">
            <ExportDeviceDashboard uid={this.props.uid} selected_farm={this.props.selected_farm} />
          </TabPane> : ''}
        {this.state.is2nsTab > 0 ?
          <TabPane tabId="2">
            <ExportDeviceSettings uid={this.props.uid} selected_farm={this.props.selected_farm} random_string={this.state.random_string} />
          </TabPane> : ''}
      </>
    );
  }

  fetchDisplayStatusDetails = () => {
    this.setState({
      is1stTab: 1,
      is2nsTab: 1,
      activeTab: "1",
    })
  }

  render() {
    // Tabs removed: one device list. Each tile shows both the device dashboard AND its
    // settings (settings are embedded per-device inside ExportDeviceDashboard's tiles).
    return (
      <CardBody>
        <ExportDeviceDashboard uid={this.props.uid} selected_farm={this.props.selected_farm} />
      </CardBody>
    );
  }
}

export default ExportDevice